import * as e from "react";
const l = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.455 8.88a1 1 0 01-.166 1.405c-.373.294-.71.631-1.004 1.004a1 1 0 01-1.57-1.239c.39-.496.84-.944 1.335-1.335a1 1 0 011.405.166z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.052 5.56a3 3 0 115.895 0A8.003 8.003 0 0120 13v4h1a1 1 0 011 1 4 4 0 01-4 4H6a4 4 0 01-4-4 1 1 0 011-1h1v-4a8.003 8.003 0 015.052-7.44zM11 5a1 1 0 111.998.062 8.082 8.082 0 00-1.996 0A1.049 1.049 0 0111 5zm-5 8a6 6 0 1112 0v4H6v-4zm13.732 6A2 2 0 0118 20H6a2 2 0 01-1.732-1h15.464z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
